import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Divider } from "@mui/material";
import { FC } from "react";

interface InvalidWasPriceConfirmationDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
}

export const InvalidWasPriceConfirmationDialog: FC<InvalidWasPriceConfirmationDialogProps> = ({
  open,
  loading,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Was Price Not Valid</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>This override cannot be submitted. One or more Was prices are invalid.</p>
          <p>Please review the table for valid values, correct the file, and re upload to proceed.</p>
          <Divider flexItem />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          Ok
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
